import {
    gtcDebounce,
    gtcAddProductToCart
} from "gtcUtils";


// Read More
class ReadMore extends HTMLElement {
    constructor() {
        super();
        this.toggle = this.toggle.bind(this);
        this.showHideButton = this.showHideButton.bind(this);
    }

    connectedCallback() {
        this.dom = {
            button: this.querySelector('button'),
            content: this.querySelector('.read-more__content')
        };

        this.addEventListeners();

        this.showHideButton();
    }

    addEventListeners() {
        this.dom.button.addEventListener('click', this.toggle);
        window.addEventListener('resize', gtcDebounce(this.showHideButton, 100));
    }

    showHideButton() {

        if (!this.dom.content) {
            console.error('Content element not found');
            return;
        }
        const contentClientHeight = this.dom.content.clientHeight;
        const contentScrollHeight = this.dom.content.scrollHeight;

        if (contentClientHeight >= contentScrollHeight) {
            this.classList.remove('read-more--hidden');
        } else {
            this.classList.add('read-more--hidden');
        }
    }


    toggle() {
        this.classList.toggle('read-more--open');
    }
}

if (!customElements.get('read-more')) {
    customElements.define('read-more', ReadMore);
}


// Custom Product Form

class CustomProductForm extends HTMLElement {
    static openClass = 'custom-quick-add--open';

    constructor() {
        super();
        this.buttonClick = this.buttonClick.bind(this);
        this.toggleForm = this.toggleForm.bind(this);

        this.settings = {
            queryID: this.getAttribute('data-query-id') || '',
            objectID: this.getAttribute('data-object-id') || '',
            position: this.getAttribute('data-position') || ''
        };
    }

    connectedCallback() {
        this.dom = {
            form: this.querySelector('form'),
            select: this.querySelector('select'),
            submitButtons: this.querySelectorAll('form button[type="submit"]'),
            variantButtons: this.querySelectorAll('button.block-swatch[type="button"]'),
            openButton: this.querySelector('.custom-quick-add__open-button'),
            closeButton: this.querySelector('.custom-quick-add__close-button')
        };
        this.addEventListeners();
    }

    addEventListeners() {
        this.dom.variantButtons.forEach(variantButton => {
            variantButton.addEventListener('click', this.buttonClick);
        });

        this.dom.openButton.addEventListener('click', this.toggleForm);
        this.dom.closeButton.addEventListener('click', this.toggleForm);
    }

    async buttonClick(event) {
        this.dom.select.value = event.target.value;
        this.classList.remove(CustomProductForm.openClass);

        gtcAddProductToCart({ variantId: this.dom.select.value, quantity: 1, properties: { '_algolia-query-id': this.settings.queryID, '_algolia-index': 'grafikr-com-products' } });
    }

    toggleForm() {
        this.classList.toggle(CustomProductForm.openClass);
    }
}

// if document ready
if (!customElements.get('custom-product-form')) {
    customElements.define('custom-product-form', CustomProductForm);
}

class CustomLazyQuickAdd extends HTMLElement {
    static openClass = 'custom-quick-add--open';
    static loadedClass = 'custom-quick-add--loaded';

    constructor() {
        super();
        this.click = this.click.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
    }

    connectedCallback() {
        this.dom = {
            openButton: this.querySelector('.custom-quick-add__open-button'),
            closeButton: this.querySelector('.custom-quick-add__close-button'),
            variantContainer: this.querySelector('.block-swatch-container')
        };


        this.settings = {
            productHandle: this.getAttribute('product-handle') || '',
            queryID: this.getAttribute('data-query-id') || '',
            objectID: this.getAttribute('data-object-id') || '',
            position: this.getAttribute('data-position') || ''
        };


        this.addEventListeners();


        this.containerItersection()
    }

    addEventListeners() {
        this.addEventListener('click', this.click);

        this.dom.openButton.addEventListener('click', this.toggleForm);
        this.dom.closeButton.addEventListener('click', this.toggleForm);
    }

    async click(event) {
        if (event.target.tagName !== 'BUTTON' || event.target.type !== 'button') return;

        this.classList.remove(CustomProductForm.openClass);
        const response = await gtcAddProductToCart({ variantId: event.target.value, quantity: 1, properties: { '_algolia-query-id': this.settings.queryID, '_algolia-index': 'grafikr-com-products' } });
        const item = response.items[0];

        if (item && this.settings.queryID && this.settings.objectID) {

            aa('addedToCartObjectIDsAfterSearch', {
                eventName: 'Product quick added',
                index: 'shopify_products',
                queryID: this.settings.queryID,
                objectIDs: [this.settings.objectID],
                value: item.price,
                currency: Shopify.currency.active,
            });
        }

    }

    toggleForm() {
        this.classList.toggle(CustomProductForm.openClass);
    }

    async loadOptions() {
        const response = await fetch(`/products/${ this.getAttribute('product-handle') }?view=custom-quick-add-endpoint`);
        const html = await response.text();
        if (this.dom.variantContainer) {
            this.dom.variantContainer.innerHTML = html;
        } else {
            console.error('Variant container not found');
        }
        this.classList.add(CustomProductForm.loadedClass);
    }

    containerItersection() {

        this.dom.variantContainer

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.loadOptions();
                    observer.unobserve(entry.target);
                }
            });
        });

        observer.observe(this);
    }
}

// if document ready
if (!customElements.get('custom-lazy-quick-add')) {
    customElements.define('custom-lazy-quick-add', CustomLazyQuickAdd);
}

class MegaMenuSubMenu extends HTMLElement {

    constructor() {
        super();
        this.menus = this.querySelectorAll('[data-submenu-handle]');
        this.triggers = this.parentElement.querySelectorAll(`[data-submenu-trigger]`);
        this.buttonIcons = Array.from(this.triggers)
            .map(trigger => trigger.querySelector('button svg'))
            .filter(trigger => trigger);
        this.promo = this.querySelector('.mega-menu__promo');
    }

    connectedCallback() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.menus.forEach(menu => menu.addEventListener('mouseleave', () => {
            if (menu.classList.contains('show')) {
                this.hideMenus();
            };
        }));

        this.triggers.forEach(trigger => {
            const handle = trigger.dataset.submenuTrigger;
            const menu = handle ? Array.from(this.menus).find(menu => menu.dataset.submenuHandle === handle) : null;
            const buttonIcon = trigger.querySelector('button svg');

            if (menu) {
                trigger.addEventListener('mouseleave', (event) => {
                    if (menu.classList.contains('show')) {
                        if (menu !== event.relatedTarget) {
                            this.hideMenus();
                        }
                    };
                });
            }

            trigger.addEventListener('mouseover', () => {
                if (menu) {
                    this.showMenu(menu, buttonIcon);
                } else {
                    this.hideMenus();
                }
            });
        })

        document.addEventListener('closing-megamenu', (event) => {
            if (this.parentElement.dataset.megamenuHandle === event.detail.handle) {
                this.hideMenus();
            }
        })
    }

    hideMenus() {
        setTimeout(() => {
            this.menus.forEach(m => {
                m.classList.remove('show');
            });
            this.buttonIcons.forEach(b => b.style.setProperty('color', '#fff'));
            this.promo.style.setProperty('opacity', '1');
        }, 1)
    }

    showMenu(menu, buttonIcon) {
        setTimeout(() => {
            this.menus.forEach(m => {
                m.classList.remove('show');
            });
            menu.classList.add('show');

            this.buttonIcons.forEach(b => b.style.setProperty('color', '#fff'));
            buttonIcon.style.setProperty('color', '#000');

            this.promo.style.setProperty('opacity', '0');
        }, 1);
    }
}

if (!customElements.get('mega-menu-submenu')) {
    customElements.define('mega-menu-submenu', MegaMenuSubMenu);
}

const setAnnouncementBarHeightProperty = () => {
    const announcements = document.querySelector('announcements-marquee');
    const visibleAnnouncementsHeight = announcements ? Math.max((announcements.getBoundingClientRect().top + announcements.getBoundingClientRect().height), 0) : 0;
    document.documentElement.style.setProperty('--actual-announcement-bar-height', `${ visibleAnnouncementsHeight.toFixed(2) }px`);
}

window.addEventListener('load', setAnnouncementBarHeightProperty);
window.addEventListener('scroll', gtcDebounce(setAnnouncementBarHeightProperty, 250));


class UrlPreload extends HTMLElement {
    constructor() {
        super();
        this.preload = this.preload.bind(this);
    }

    connectedCallback() {
        this.addEventListeners();
    }

    disconnectedCallback() {
        this.removeEventListeners();
    }

    addEventListeners() {
        this.addEventListener('mouseover', this.preload, { once: true });
    }

    removeEventListeners() {
        this.removeEventListener('mouseover', this.preload, { once: true });
    }

    preload() {
        const links = [...this.querySelectorAll('a[href]')].map(link => link.href);

        const uniqueLinks = Array.from(new Set(links));

        if (!uniqueLinks) return;

        uniqueLinks.forEach(link => {

            const specScript = document.createElement("script");
            specScript.type = "speculationrules";

            // Create speculationruleset object
            const specRules = {
                prefetch: [
                    {
                        urls: [link],
                    },
                ]
            };

            specScript.textContent = JSON.stringify(specRules);
            document.body.append(specScript);
        });
    }
}
if (!customElements.get('url-preload')) {
    customElements.define('url-preload', UrlPreload);
}


class customAccordion extends HTMLElement {

    static get observedAttributes() {
        return ['open'];
    }

    get isOpen() {
        return this.getAttribute('open') === "true";
    }
    set isOpen(value) {
        this.setAttribute('open', value ? "true" : "false");
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'open' && oldValue !== newValue) {
            if (newValue === 'true') {
                document.addEventListener('click', this.clickOutside);
            } else {
                document.removeEventListener('click', this.clickOutside);
            }
        }
    }




    constructor() {
        super();
        this.toggle = this.toggle.bind(this);
        this.clickOutside = this.clickOutside.bind(this);
    }

    connectedCallback() {
        this.dom = {
            toggle: this.querySelector('[data-toggle]'),
            content: this.querySelector('[data-content]')
        };

        this.addEventListeners();
    }

    disconnectedCallback() {
        this.removeEventListeners();
    }

    addEventListeners() {
        this.dom.toggle.addEventListener('click', this.toggle);
    }

    removeEventListeners() {
        this.dom.toggle.removeEventListener('click', this.toggle);
        document.removeEventListener('click', this.clickOutside);
    }

    toggle() {
        this.hasAttribute('open') ? this.removeAttribute('open') : this.setAttribute('open', true);
    }

    clickOutside(event) {
        if (!this.contains(event.target)) {
            this.removeAttribute('open');
        }
    }

}

if (!customElements.get('custom-accordion')) {
    customElements.define('custom-accordion', customAccordion);
}


class algoliaSortPopover extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.dom = {
            sortOptionsContainer: this.querySelector('[data-sort-options]'),
            select: null,
            toggleButton: document.querySelector('[aria-controls="sort-by-popover"]')
        };
        this.settings = {
            options: []
        };
        this.strings = {
            header: this.getAttribute('data-sort-by-text')?.textContent || 'Sort By'
        };

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // Check if a <select> element is added
                    mutation.addedNodes.forEach(node => {

                        if (node.classList && node.classList.contains('ais-SortBy')) {
                            const select = node.querySelector('select');
                            this.dom.select = select;
                            this.init();
                            observer.disconnect();
                        }
                    });
                }
            }
        });
        observer.observe(this.dom.sortOptionsContainer, { childList: true, subtree: true });
    }


    async init() {
        this.dom.toggleButton.removeAttribute('disabled');
        await this.getOptions();
        await this.render();
        this.addEventListeners();
    }

    addEventListeners() {
        this.dom.sortOptionButtons.forEach(button => {
            button.addEventListener('click', this.sortButtonClick.bind(this));
        });
    }

    getOptions() {
        this.settings.options = [...this.dom.select.options].map(option => ({
            name: option.textContent,
            value: option.value
        }));
    }

    sortButtonClick(event) {
        const button = event.currentTarget;
        this.dom.select.value = button.value;
        this.dom.sortOptionButtons.forEach(i => {
            if (i === button) {
                i.setAttribute('aria-selected', 'true');
                return;
            }
            i.setAttribute('aria-selected', 'false');

        });

        this.dom.select.dispatchEvent(new Event('change'));
        this.dom.toggleButton.click();
    }

    async render() {
        this.insertAdjacentHTML('beforeend', this.popoverHTML(this.settings.options));
        this.dom.sortOptionButtons = this.querySelectorAll('[data-sort-option]');
    }

    popoverHTML(options) {
        return `
        <facets-sort-popover
            id="sort-by-popover"
            section-id="${ this.getAttribute('section-id') }"
            class="popover popover--bottom-end color-scheme color-scheme--dialog"
            close-on-listbox-select
        >
            <p class="h4" slot="header">${ this.strings.header }</p>
            <div class="popover__value-list">
                ${ options.map(option => this.optionHTML(option)).join('') }
            </div>
        </facets-sort-popover>`;
    }

    optionHTML(option) {
        return `
            <button
            data-sort-option
            type="button"
            class="popover__value-option group"
            role="option"
            value="${ option.value }"
            ${ option.value === this.dom.select.value ? 'aria-selected="true"' : '' }
            >
            <span class="reversed-link">${ option.name }</span>
            </button>`;
    }
}

if (!customElements.get('algolia-sort-popover')) {
    customElements.define('algolia-sort-popover', algoliaSortPopover);
}

const dataDisabledBtn = document.querySelector('[data-disabled]');
const dataSelectVariantError = document.querySelector('[data-select-variant-error]');

if (dataDisabledBtn && dataSelectVariantError) {
    dataDisabledBtn.parentElement.addEventListener('click', () => {
        if (dataDisabledBtn.hasAttribute('disabled')) {
            dataSelectVariantError.classList.add('active');
            if (dataSelectVariantError.getBoundingClientRect().top < 66) {
                dataSelectVariantError.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });
}